import TextWordCharacterCount from "@plugins/character-count/components/TextWordCharacterCount";

const Plugin = {
  install(app) {
    app.component("text-word-character-count", TextWordCharacterCount);
  },
};

export default Plugin;
